// Manages: households/{householdId}/budget/cats
import { write } from '@/lib/firebase';

const catsPath = (householdId) => `households/${householdId}/budget/cats`;

export const categoryService = {
  async save(householdId, cats) {
    await write(catsPath(householdId), cats);
  },

  async addIncomeCategory(householdId, cats, name) {
    const updated = { ...cats, income: [...(cats.income || []), name] };
    await write(catsPath(householdId), updated);
  },

  async removeIncomeCategory(householdId, cats, index) {
    const updated = { ...cats, income: (cats.income || []).filter((_, i) => i !== index) };
    await write(catsPath(householdId), updated);
  },

  async addExpenseGroup(householdId, cats, groupName) {
    if ((cats.expense || {})[groupName]) return;
    // Firebase strips empty arrays, so use a sentinel value that useCategories filters out
    const updated = { ...cats, expense: { ...(cats.expense || {}), [groupName]: [".empty"] } };
    await write(catsPath(householdId), updated);
  },

  async removeExpenseGroup(householdId, cats, groupName) {
    const expense = { ...(cats.expense || {}) };
    delete expense[groupName];
    const updated = { ...cats, expense };
    await write(catsPath(householdId), updated);
  },

  async addSubCategory(householdId, cats, group, name) {
    const items = [...((cats.expense || {})[group] || []), name];
    const updated = { ...cats, expense: { ...(cats.expense || {}), [group]: items } };
    await write(catsPath(householdId), updated);
  },

  async removeSubCategory(householdId, cats, group, index) {
    const items = ((cats.expense || {})[group] || []).filter((_, i) => i !== index);
    const updated = { ...cats, expense: { ...(cats.expense || {}), [group]: items } };
    await write(catsPath(householdId), updated);
  },
};
